<script setup lang="ts">
import type { TestimonialsData } from '~/utils/crystallize/pieces'

defineProps<{
  data: TestimonialsData
}>()
</script>

<template>
  <section class="w-full py-xl md:pt-4xl md:pb-40 bg-blurple-500">
    <ContentGrid class="gap-y-12 md:gap-y-20">
      <div class="col-span-4 lg:col-span-6 lg:col-start-2 2xl:col-start-4 text-center flex flex-col gap-s">
        <h3 class="title-xl text-blurple-200" v-text="data.title" />
        <p v-if="data.subtitle" class="text-white title-m" v-text="data.subtitle" />
      </div>

      <template v-if="data.logos?.images?.length">
        <Carousel v-slot="{ item: logo }" class="md:hidden [--item-width:65%] xs:[--item-width:50%] sm:[--item-width:33%] col-span-full [--gap:theme(spacing.xl)]" :data="data.logos.images" autoscroll center-cards>
          <CrystallizeImage :image="logo" img-class="w-36" />
        </Carousel>
        <div class="hidden md:flex flex-wrap gap-x-xl lg:-mx-[--gutter] gap-y-11 justify-center items-center fill-white col-span-full lg:col-span-6 lg:col-start-2 2xl:col-span-8 2xl:col-start-3">
          <CrystallizeImage v-for="logo in data.logos.images" :key="logo.url" :image="logo" class="hidden md:block w-36" />
        </div>
      </template>

      <CrystallizeQuote v-if="data.quote" :data="data.quote" class="col-span-full lg:col-span-6 lg:col-start-2 2xl:col-span-8 2xl:col-start-3 text-white" />
    </ContentGrid>
  </section>
</template>
